import React, { Component } from 'react';
import { connect } from 'react-redux';
import M from 'materialize-css/dist/js/materialize.min.js'
import Modal from '../helper/modal';
import {txURL} from '../../config';

let modalId = 'modalEvents'

let overflow = "hidden";
let textOverflow = 'ellipsis';

// when Tx #${txHash} is ${isMaker ? 'fulfilled': 'mined into a block'

class ScheduledEvents extends Component {
  scheduledEventsModal(){
    let title = `Scheduled Events: ${this.props.scheduledEvents}`
    let component = this.eventsTable()
    return (
      <Modal id={modalId} classes='modal' title={title} component={component}/>
    )
  }
  eventsTable(){
    let items = this.props.events.map(({amount,to,from,chain, txHash,isMaker}) => {
      return (<tr><td>
        {`Send ${amount} ${chain.toUpperCase()} to ${to} from ${from}`}
      </td></tr>)
    })
    return (
      <div style={{height:'350px',overflowY:'scroll'}}>
        <table className="black-text" style={{tableLayout:"fixed",fontSize:"0.85em"}}>
          <thead>
            <tr>
              <th>Event Description</th>
            </tr>
          </thead>
          <tbody style={{lineHeight:'30px',padding:'0px'}}>
            {items}
          </tbody>
        </table>
      </div>
    )
  }
  openModal(){
    var instance = M.Modal.getInstance(document.querySelectorAll(`#${modalId}`)[0]);
    instance.open();
  }
  render() {
    let num = this.props.scheduledEvents
    if(num != 0) {
      return (
        <li>
          <a className='scheduleEvents rightLink' href='#!' onClick={this.openModal.bind(this)}> SCHEDULED EVENTS ({num}) </a>
          {this.scheduledEventsModal()}
        </li>
      )
    }
    else return null
  }
}

function mapStateToProps(state,props) {

  let scheduledEvents = state.scheduled_events.events;
  let events = scheduledEvents ? Object.keys(scheduledEvents).map(key=>scheduledEvents[key]) : [];
  scheduledEvents = events.length > 0 ? Object.keys(scheduledEvents).length : 0;

  return {
    address: state.passport.wallet && state.passport.wallet.emb ? state.passport.wallet.emb.address : '',
    events,
    scheduledEvents,
  };
}

//
export default connect(mapStateToProps, {})(ScheduledEvents);
